/* Common Imports */

import React from "react";

/* Redux Imports */

/* Component Imports */

import CloseIcon from "@mui/icons-material/Close";
import { Badge, Button, Dialog, DialogContent, DialogTitle, IconButton, styled, Switch, Typography } from "@mui/material";

/* Icon Imports */

import { NotificationsNoneOutlined } from "@mui/icons-material";

const NotificationContent = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "flex-start",
	alignItems: "center",
	gap: "0.75rem",
	// width: "100%",
}));

const ActionActions = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: "1rem",
	margin: "0.35rem 0rem",
}));

const Description = styled(Typography)(({ theme }) => ({
	fontWeight: "400",
	fontSize: "1rem",
	lineHeight: "1rem",
	width: "100%",
}));

const NotificationContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "flex-start",
	alignItems: "flex-start",
	gap: "0.75rem",
	width: "100%",
	textDecoration: "none",
	"@media (pointer: fine)": {
		"&:hover": {
			backgroundColor: theme.palette.mode === "dark" ? "rgba(0, 0, 0, 0.04)" : "rgba(0, 0, 0, 0.04)",
		},
	},
	cursor: "pointer",
}));

const AntSwitch = styled(Switch)(({ theme }) => ({}));

const Notifications = ({
	session,
	new_notification,
	showNotification,
	setShowNotification,
}: {
	session: any;
	new_notification: any;
	showNotification?: boolean;
	setShowNotification?: any;
}) => {
	const [loading, setLoading] = React.useState<boolean>(false);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const id = open ? "simple-popover" : undefined;

	const [notifications, setNotifications] = React.useState<any>([]);
	const [notificationCount, setNotificationCount] = React.useState<number>(0);

	React.useEffect(() => {
		if (new_notification) {
			notifications.length > 0
				? setNotifications((prevNotifications: any) => [new_notification, ...prevNotifications])
				: setNotifications([new_notification]);
			setNotificationCount(notificationCount + 1);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [new_notification]);

	const handleClick = async (event: any) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
		setNotificationCount(0);
	};

	return (
		<React.Fragment>
			<IconButton
				onClick={handleClick}
				sx={{ color: "#616161" }}
			>
				<Badge
					badgeContent={loading ? 0 : notificationCount >= 10 ? "9+" : notificationCount}
					color="primary"
					sx={{
						"& .MuiBadge-badge": {
							backgroundColor: "primary.main", // Change background color
							color: "#fff", // Change text color
						},
					}}
				>
					<NotificationsNoneOutlined sx={{ fontSize: "1.5rem" }} />
				</Badge>
			</IconButton>
			<Dialog
				open={Boolean(anchorEl)}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				fullWidth={true}
				fullScreen={true}
			>
				<DialogTitle
					sx={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						justifyContent: "space-between",
						color: "primary.main",
					}}
					component="div"
				>
					{" "}
					<Typography
						sx={{
							fontSize: "1.5rem",
							fontWeight: "bold",
						}}
					>
						Notifications
					</Typography>
					<ActionActions>
						<ActionActions
							sx={{
								border: "1px solid",
								borderRadius: "1rem",
								padding: "0rem 0.5rem 0rem 0.5rem",
							}}
						>
							<Typography
								sx={{
									color: showNotification ? "text.primary" : "#FF0000",
									fontWeight: showNotification ? "normal" : "bold",
								}}
							>
								OFF
							</Typography>
							<AntSwitch
								checked={showNotification}
								onChange={() => {
									setShowNotification(!showNotification);
								}}
								inputProps={{ "aria-label": "ant design" }}
							/>
							<Typography
								sx={{
									color: showNotification ? "#078a32" : "text.primary",
									fontWeight: showNotification ? "normal" : "bold",
								}}
							>
								ON
							</Typography>
						</ActionActions>
					</ActionActions>
					<IconButton
						aria-label="close"
						onClick={handleClose}
					>
						<CloseIcon
							sx={{
								color: "primary.main",
								fontSize: "1.5rem",
							}}
						/>
					</IconButton>
				</DialogTitle>
				<DialogContent>
					{notifications.length > 0 ? (
						notifications.map((notification: any, index: number) => {
							return (
								<NotificationContainer
									key={index}
									sx={{
										padding: "0.75rem 1rem 0.75rem 1rem",
									}}
								>
									<NotificationContent
										sx={{
											padding: "0rem 0rem 0rem 0.5rem",
										}}
									>
										<Description
											variant="body1"
											color={notification.color}
										>
											{/* Bold multiple substrings between ** characters */}
											{notification.content.split("**").map((item: any, index: number) => {
												if (index % 2) {
													return <b key={index}>{item}</b>;
												} else {
													return <span key={index}>{item}</span>;
												}
											})}{" "}
										</Description>
										{notification.url ? (
											<Button
												variant="outlined"
												sx={{
													padding: "0.1rem",
													textDecoration: "none",
													borderRadius: "1rem",
													// backgroundColor: "primary.main",
													// color: "#FFFFFF",
												}}
												href={notification.url}
												target="_blank"
											>
												view
											</Button>
										) : null}
									</NotificationContent>
								</NotificationContainer>
							);
						})
					) : (
						<ActionActions
							sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
								justifyContent: "center",
								height: "100%",
							}}
						>
							<Typography variant="body1">No new notifications</Typography>
						</ActionActions>
					)}
				</DialogContent>
			</Dialog>
		</React.Fragment>
	);
};
export default Notifications;
